import React from 'react';
import {injectIntl} from 'react-intl';
import {Redirect} from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';

import API from '../../common/utils/API';
import {formatErrorMessageFromAPI} from '../../common/utils/helpers';
import Form from '../../components/form/states/StateForm';

export class CreateState extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: [],

            // Redirects
            shouldRedirectToIndex: false,

            // Errors
            errorMessage: '',

            // Loading
            loading: false,
        };
    }

    async componentDidMount() {
        await this.fetchCountries();
    }

    fetchCountries = async () => {
        this.setState({loading: true});

        try {
            const {countries} = await API.countries.getAll();

            this.setState({
                countries,
                loading: false,
            });
        } catch (e) {
            this.setState({
                errorMessage: this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.LOADING_DATA',
                }),
                loading: false,
            });
        }
    };

    onSubmit = async (input) => {
        this.setState({loading: true});

        try {
            await API.states.save(input);

            this.setState({loading: false, shouldRedirectToIndex: true});
        } catch (e) {
            const error = formatErrorMessageFromAPI(
                e,
                this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.STORING_DATA',
                }),
            );

            this.setState({
                ...error,
            });
        }
    };

    render() {
        const {shouldRedirectToIndex} = this.state;
        const countries = this.state.countries.map((country) => ({
            value: country.id,
            label: country.name,
        }));
        const initialValues = {
            name: '',
            country: '',
            code: '',
        };

        return shouldRedirectToIndex ? (
            <Redirect
                data-test='redirectToIndex'
                to={{
                    pathname: '/states',
                    state: {
                        successMessage: this.props.intl.formatMessage({
                            id: 'STATES.STATE_SUCCESSFULLY_CREATED_MESSAGE',
                        }),
                    },
                }}
            />
        ) : (
            <>
                <Alert
                    variant='danger'
                    className='mb-4'
                    show={!!this.state.errorMessage}
                >
                    <p className='mb-0'>{this.state.errorMessage}</p>
                </Alert>
                <Form
                    data-test='createStateComponent'
                    initialValues={initialValues}
                    backRedirectUrl='/states'
                    backText={this.props.intl.formatMessage({
                        id: 'LIST.BACK_TO_LIST',
                    })}
                    countries={countries}
                    loading={this.state.loading}
                    handleSubmit={this.onSubmit}
                />
            </>
        );
    }
}

export default injectIntl(CreateState);
